import { createContext, useContext } from 'react'

import type { PopoverPosition } from '../Popover/popoverTypes'
import type { MenuSize } from './constants'

export type MenuItemClickCallback = (id: string) => void

const menuContext = createContext<{
  onRowClick?: MenuItemClickCallback
  size: MenuSize
  parentPosition?: PopoverPosition
}>({ size: 'medium' })

export const MenuProvider = menuContext.Provider

export const useMenuContext = () => useContext(menuContext)
